/* 検索項目 チェックボックス */
import React, { memo } from 'react';
import SearchLabel from '../atoms/SearchLabel';
import { Col, Form, InputGroup } from 'react-bootstrap';
import Messages from './Messages';
var SearchCheckBox = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, name = _a.name, sources = _a.sources, column = _a.column, help_msg = _a.help_msg, message = _a.message, disabled = _a.disabled, handleChange = _a.handleChange;
    return (React.createElement(Col, { className: "search-check-box", md: column ? column : 4 },
        React.createElement(SearchLabel, { label: label }),
        React.createElement(InputGroup, null, sources.map(function (src, index) {
            return (React.createElement("label", { className: "search-check-box-label", key: src.key },
                React.createElement(Form.Check, { disabled: disabled, id: id + "-" + index, type: "checkbox", inline: true, value: src.key, name: name, onChange: handleChange, className: "" + id, checked: value.includes(src.key) }),
                src.value));
        })),
        disabled || React.createElement(Messages, { help_msg: help_msg, valid_msg: message })));
};
export default memo(SearchCheckBox);
